// survey submission service
export default {
  install: (Vue) => {
    //private
    const route = process.env.VUE_APP_API_BASE_URL + '/api/survey-submissions';

    //public
    Vue.$surveySubmissionService = {
      find(params) {
        return Vue.axios.get(route, {
          params: params
        });
      },

      async save(submission) {
        if (submission.id) {
          return (await Vue.axios.put(`${route}/${submission.id}`, {
            data: submission
          })).data.data;
        }

        return (await Vue.axios.post(route, {
          data: submission
        })).data.data;
      }
    };
  }
};
